export const Loading = () => (
  <div className="my-4 text-center">
    <div className="spinner-border text-light" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);
